import { Component, Input, OnInit } from '@angular/core';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { UpdateMission } from '../../../store/actions/mission.actions';
import { Store } from '@ngrx/store';
import { ActivateSimCardInterface } from '../../../models/activate-sim-card.interface';
import { LineInterface } from '../../../../lines/models/line.interface';

@Component({
    selector: 'app-activate-sim-card',
    templateUrl: './activate-sim-card.component.html',
    styleUrls: ['./activate-sim-card.component.css'],
    standalone: false
})
export class ActivateSimCardComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  lastMessage?: Array<any>;

  step: number;
  formSubmitted: boolean;
  isEsim: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.step = 1;
    this.isEsim = false;
    this.formSubmitted = false;
    if (this.lastMessage && this.lastMessage['route_value'] && this.lastMessage['route_value'] === 'esim') {
      this.isEsim = true;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    this.step = step;
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      const activateSimCardInterface = {
        step: 1,
        activation: true,
        phoneNumber: this.line.phoneNumber,
        isEsim: this.isEsim
      } as ActivateSimCardInterface;
      this.store.dispatch(new UpdateMission(activateSimCardInterface, this.procedureCode));
    }
  }
}
